// Given a cookie key `name`, returns the value of
// the cookie or `null`, if the key is not found.
// Reference: https://gist.github.com/hunan-rostomyan/28e8702c1cecff41f7fe64345b76f2ca
export const getCookie = (name: string): string | null => {
	const nameIncrement = (name.length + 1);
	return document.cookie
        .split(';')
        .map(cookie => cookie.trim())
        .filter(cookie => {
            return cookie.substring(0, nameIncrement) === `${name}=`;
        })
        .map(cookie => {
            return decodeURIComponent(cookie.substring(nameIncrement));
        })[0] || null;
}